import { createI18n } from 'vue-i18n'

export const defaultLocale = 'en'
// TODO: fr, es, zh-CN, pt-BR, uz, uk-UA — вернуть, когда будут готовы локали (src/locales/*.json)
export const availableLang = ['en', 'ru']

export const langLabels = {
  en: 'EN',
  ru: 'RU',
  // fr: 'FR',
  // es: 'ES',
  // 'zh-CN': '中文',
  // 'pt-BR': 'PT-BR',
  // uz: "O'ZBEK",
  // 'uk-UA': 'UA'
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'))
  return match ? decodeURIComponent(match[1]) : null
}

function setSharedCookie(name, value) {
  document.cookie = `${name}=${encodeURIComponent(value)}; domain=.graspil.com; path=/; max-age=${365 * 24 * 3600}; SameSite=Lax`
}

// 1. Default
let currentLang = defaultLocale

// 2. Browser language (only switch away from the default if we have a match)
const browserLang = navigator.language?.split('-')[0]
if (browserLang) {
  const matched = availableLang.find(l => l === browserLang || l.split('-')[0] === browserLang)
  if (matched) {
    currentLang = matched
  }
}

// 3. Cookie overrides browser language (shared cross-subdomain cookie has priority)
const cookieLang = getCookie('graspil_lang') || getCookie('lang')
if (cookieLang && availableLang.includes(cookieLang)) {
  currentLang = cookieLang
}

// 4. URL param has highest priority
const params = (new URL(document.location)).searchParams
const paramLang = params.get('lang')
if (paramLang && availableLang.includes(paramLang)) {
  currentLang = paramLang
}


function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const i18n = createI18n({
  locale: currentLang,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})

export async function switchLang(locale) {
  if (i18n.global.locale === locale) {
    return false
  }
  if (!availableLang.includes(locale)) {
    return false
  }
  i18n.global.locale = locale
  setSharedCookie('graspil_lang', locale)
}

export default i18n
